import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { ChildrenOutletContexts, Router } from '@angular/router';
import constant from 'src/app/app.constant';
import { LocalStorageService } from 'src/app/utils/local-storage.service';
import * as _ from 'lodash';

// Menu
export interface Menu {
	headTitle1?: string,
	headTitle2?: string,
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService implements OnDestroy {

	private unsubscriber: Subject<any> = new Subject();
	public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

	// Search Box
	public search: boolean = false;

	// Language
	public language: boolean = false;

	// Mega Menu
	public megaMenu: boolean = false;
	public levelMenu: boolean = false;
	public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

	// Collapse Sidebar
	public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

	// Full screen
	public fullScreen: boolean = false;

	constructor(private router: Router, private localData: LocalStorageService) {
		this.setScreenWidth(window.innerWidth);
		fromEvent(window, 'resize').pipe(
			debounceTime(1000),
			takeUntil(this.unsubscriber)
		).subscribe((evt: any) => {
			this.setScreenWidth(evt.target.innerWidth);
			if (evt.target.innerWidth < 991) {
				this.collapseSidebar = true;
				this.megaMenu = false;
				this.levelMenu = false;
			}
			if (evt.target.innerWidth < 1199) {
				this.megaMenuColapse = true;
			}
		});
		if (window.innerWidth < 991) { // Detect Route change sidebar close
			this.router.events.subscribe(event => {
				this.collapseSidebar = true;
				this.megaMenu = false;
				this.levelMenu = false;
			});
		}
	}

	ngOnDestroy() {
		this.unsubscriber.next();
		this.unsubscriber.complete();
	}

	private setScreenWidth(width: number): void {
		this.screenWidth.next(width);
	}

	MENUITEMS: Menu[] = [
		// // {
		// // 	headTitle1: 'Sample', headTitle2: 'Ready Sample Page.',
		// // },
		// // {
		// // 	title: 'Sample Page', icon: 'home', type: 'sub', badgeType: 'success', badgeValue: '2', active: true, children: [
		// // 		{ path: '/sample-page', title: 'Sample 1', type: 'link' },
		// // 		{ path: 'javascript:void(0);', title: 'Sample 2', type: 'extLink' }
		// // 	]
		// // },
		// {
		// 	headTitle1: 'Analytics', headTitle2: 'Dashboard and AI.',
		// },
		// {
		// 	path: '/dashboard/default', title: 'Dashboard', icon: 'home', type: 'link', bookmark: true
		// },
		// {
		// 	headTitle1: 'General', headTitle2: 'lorem ipsum.',
		// },
		{
			title: 'Ondc.Text', icon: 'globe', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
			children: [
				// { path: '/masters/employee', title: 'Master.Employee', type: 'link' },
				{ path: '/ondc/orderlist', title: 'Ondc.Order', type: 'link', bookmark: true },
				{ path: '/ondc/igm', title: 'Ondc.Igm', type: 'link', bookmark: true },
				{ path: '/ondc/rsp', title: 'Ondc.Rsp', type: 'link', bookmark: true },
			]
		},

		// // {
		// // 	// title: 'Request.Text', icon: 'git-pull-request', type: 'sub', badgeValue: '04', badgeType: 'success', active: true,
		// // 	// children: [
		// // 	// 	{ path: '/masters/employee1', title: 'Request.MasterAgency', type: 'link' },
		// // 	// 	{ path: '/masters/employee1', title: 'Request.Agency', type: 'link' },
		// // 	// 	{ path: '/masters/employee1', title: 'Request.Vendor', type: 'link' },
		// // 	// 	{ path: '/masters/employee1', title: 'Request.DeliveryPartner', type: 'link' },
		// // 	// ]
		// // },
		// {
		// 	title: 'Orders.Text', icon: 'pocket', type: 'sub', badgeValue: '04', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/orders/list', title: 'Orders.BookingOrder', type: 'link' },
		// 		// { path: '/masters/employee1', title: 'Orders.MultipleOrder', type: 'link' },
		// 		{ path: '/orders/offOrder', title: 'Orders.OfflineOrder', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Report.Text', icon: 'file-text', type: 'sub', badgeValue: '08', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'Report.Customers', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Report.MasterAgency', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Report.Agency', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Report.Vendor', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Report.Deliverystaff', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Report.OrdersReport', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Report.Growth', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Report.Commission', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'ActionManage.Text', icon: 'database', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'ActionManage.BillPayment', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'ActionManage.PaymentReport', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'PricingAndTax.Text', icon: 'dollar-sign', type: 'sub', badgeValue: '04', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'PricingAndTax.Order', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'PricingAndTax.DeliveryStaff', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'PricingAndTax.MasterAgency', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'PricingAndTax.Agency', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'PricingAndTax.Vendor', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'InvoiceManage.Text', icon: 'file-plus', type: 'sub', badgeValue: '03', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'InvoiceManage.MasterAgency', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'InvoiceManage.Agency', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'InvoiceManage.Vendor', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Setting.Text', icon: 'settings', type: 'sub', badgeValue: '08', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'Setting.Packages', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Setting.Countries', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Setting.States', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Setting.Cities', type: 'link' },
		// 		// {
		// 		// 	title: 'Category', type: 'sub', active: true, badgeValue: '02', badgeType: 'success',
		// 		// 	children: [
		// 		// 		{ path: '/masters/employee1', title: 'Setting.Delivery', type: 'link' },
		// 		// 		{ path: '/masters/employee1', title: 'Setting.Service', type: 'link' },
		// 		// 	]
		// 		// },
		// 		{ path: '/masters/employee1', title: 'Setting.Vehicle', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Setting.Announcement', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Setting.Offers', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Setting.SmsSettings', type: 'link' },
		// 		// {
		// 		// 	title: 'Setting.AppManagement', type: 'sub', active: true, badgeValue: '03', badgeType: 'success',
		// 		// 	children: [
		// 		// 		{ path: '/masters/employee1', title: 'Setting.Vendor', type: 'link' },
		// 		// 		{ path: '/masters/employee1', title: 'Setting.Rider', type: 'link' },
		// 		// 		{ path: '/masters/employee1', title: 'Setting.Customer', type: 'link' },
		// 		// 	]
		// 		// },
		// 	]
		// },
		// {
		// 	title: 'EmployeeCRM.Text', icon: 'book-open', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'EmployeeCRM.EmployeePayroll', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'EmployeeCRM.EmployeeStatistics', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'CustomerSupport.Text', icon: 'users', type: 'sub', badgeValue: '4', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'CustomerSupport.Feedback', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'CustomerSupport.CustomerQueries', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'CustomerSupport.MasterAgencyQueries', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'CustomerSupport.AgencyQueries', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'CustomerSupport.VendorQueries', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'CustomerSupport.DeliveryStaffQueries', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Maps.Text', icon: 'map', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
		// 	children: [
		// 		{ path: '/masters/employee1', title: 'Maps.CountryHead', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Maps.Master', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Maps.Agency', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Maps.Vendor', type: 'link' },
		// 		{ path: '/masters/employee1', title: 'Maps.DeliveryStaff', type: 'link' },
		// 	]
		// },

	];

	MEGAMENUITEMS: Menu[] = [
		{
			title: 'Error Pages', type: 'sub', active: true, children: [
				{ path: 'javascript:void(0);', title: 'Error Page 400', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Error Page 401', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Error Page 403', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Error Page 404', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Error Page 500', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Error Page 503', type: 'extLink' },
			]
		},
		{
			title: 'Authentication', type: 'sub', active: false, children: [
				{ path: 'javascript:void(0);', title: 'Login Simple', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Login BG Image', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Login BG Video', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Simple Register', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Register BG Image', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Register BG Video', type: 'extLink' }
			]
		},
		{
			title: 'Usefull Pages', type: 'sub', active: false, children: [
				{ path: 'javascript:void(0);', title: 'Search Pages', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Unlock User', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Forgot Password', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Reset Password', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Maintenance', type: 'extLink' }
			]
		},
		{
			title: 'Email templates', type: 'sub', active: false, children: [
				{ path: 'http://admin.pixelstrap.com/cuba/theme/basic-template.html', title: 'Basic Email', type: 'extTabLink' },
				{ path: 'http://admin.pixelstrap.com/cuba/theme/email-header.html', title: 'Basic With Header', type: 'extTabLink' },
				{ path: 'http://admin.pixelstrap.com/cuba/theme/template-email.html', title: 'Ecomerce Template', type: 'extTabLink' },
				{ path: 'http://admin.pixelstrap.com/cuba/theme/template-email-2.html', title: 'Email Template 2', type: 'extTabLink' },
				{ path: 'http://admin.pixelstrap.com/cuba/theme/ecommerce-templates.html', title: 'Ecommerce Email', type: 'extTabLink' },
				{ path: 'http://admin.pixelstrap.com/cuba/theme/email-order-success.html', title: 'Order Success', type: 'extTabLink' }
			]
		},
		{
			title: 'Coming Soon', type: 'sub', active: false, children: [
				{ path: 'javascript:void(0);', title: 'Coming Simple', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Coming BG Image', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Coming BG Video', type: 'extLink' }
			]
		},
	];

	LEVELMENUITEMS: Menu[] = [
		{
			path: 'javascript:void(0);', title: 'File Manager', icon: 'git-pull-request', type: 'extLink'
		},
		{
			title: 'Users', icon: 'users', type: 'sub', active: false, children: [
				{ path: 'javascript:void(0);', title: 'All Users', icon: 'users', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'User Profile', icon: 'users', type: 'extLink' },
				{ path: 'javascript:void(0);', title: 'Edit Profile', icon: 'users', type: 'extLink' },
			]
		},
		{ path: 'javascript:void(0);', title: 'Bookmarks', icon: 'heart', type: 'extLink' },
		{ path: 'javascript:void(0);', title: 'Calender', icon: 'calendar', type: 'extLink' },
		{ path: 'javascript:void(0);', title: 'Social App', icon: 'zap', type: 'extLink' }
	];

	HEADERITEMS: Menu[] = []

	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
	megaItems = new BehaviorSubject<Menu[]>(this.MEGAMENUITEMS);
	levelmenuitems = new BehaviorSubject<Menu[]>(this.LEVELMENUITEMS);
	headerItems = new BehaviorSubject<Menu[]>(this.HEADERITEMS);

	dynamicMenuBuilder(value: any) {

		// value = JSON.parse(value)
		// console.log(value)
		value = value;
		// console.log("value", JSON.stringify(value))
		var menuJson: any = [];
		var headerMenuArray: any = [];
		var headerMenuJson: any = {};
		// var trackMenuJson: any = [];
		// var trackJson: any = {};
		// if (value.trackOrder?.access) {
		// 	headerMenuJson = { icon: 'inbox', path: '/orders/ordertracking', title: 'TrackOrder.Text', type: 'link', bookmark: true };
		// 	headerMenuArray.push(headerMenuJson)
		// }
		// if (value?.quickOrder?.access && this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.vendor) {
		// 	headerMenuJson = { icon: 'layers', path: '/orders/vendororder', title: 'QuickOrder.Text', type: 'link', bookmark: true };
		// 	headerMenuArray.push(headerMenuJson)
		// }
		//  else {
		// 	headerMenuJson = { icon: 'layers', path: '/orders/add', title: 'QuickOrder.Text', type: 'link', bookmark: true };
		// 	headerMenuArray.push(headerMenuJson)
		// }
		if (value?.openOrders?.access) {
			// if ([constant.RoleId.agency, constant.RoleId.masterAgency, constant.RoleId.vendorAgency].includes(this.localData.getItem(constant.localStorage.user_role_id))) {
			// 	headerMenuJson = { icon: 'book-open', path: '/orders/openorder', title: 'OpenOrder.Text', type: 'link', bookmark: true }
			// 	headerMenuArray.push(headerMenuJson)
			// }
		}

		// this.items.next(menuJson)
		var reqJson: any = {};
		if (value?.superAdminDashboard?.access) {
			reqJson = { icon: 'home', path: '/dashboard/default', title: 'Dashboard.Text', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}
		if (value?.cmDashboard?.access) {
			reqJson = { icon: 'home', path: '/dashboard/customermaster', title: 'Dashboard.Text', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}
		if (value?.cgDashboard?.access) {
			reqJson = { icon: 'home', path: '/dashboard/customergroup', title: 'Dashboard.Text', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}
		if (value?.maDashboard?.access) {
			reqJson = { icon: 'home', path: '/dashboard/masteragency', title: 'Dashboard.Text', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}
		if (value?.agencyDashboard?.access) {
			reqJson = { icon: 'home', path: '/dashboard/agency', title: 'Dashboard.Text', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}
		if (value?.vendorDashboard?.access) {
			reqJson = { icon: 'home', path: '/dashboard/customer', title: 'Dashboard.Text', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}
		if (value?.vaDashboard?.access) {
			reqJson = { icon: 'home', path: '/dashboard/customeradmin', title: 'Dashboard.Text', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}

		if (value.masters && value.masters.access) {
			if (value.masters.access) {
				reqJson = {
					title: 'Master.Text', icon: 'layout', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
					children: []
				};

				for (let key2 in value.masters) {
					if ((key2 === 'admin') && value.masters[key2].access) reqJson.children.push({ path: '/masters/admin', title: 'Master.Admin', type: 'link', bookmark: true });
					if ((key2 === 'admin') && value.masters[key2].access) {
						// if (this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.superAdmin) {
						// 	reqJson.children.push({ icon: 'layers', path: '/masters/orderingpartner', title: 'Master.OrderingPartner', type: 'link', bookmark: true });
						// }
					}
					if ((key2 === 'masterAgency') && value.masters[key2].access) reqJson.children.push({ path: '/masters/masteragency', title: 'Master.MasterAgency', type: 'link', bookmark: true, typeOf: 'MasterSAAS' });
					if ((key2 === 'agency') && value.masters[key2].access) reqJson.children.push({ path: '/masters/agency', title: 'Master.Agency', type: 'link', bookmark: true, typeOf: 'AgencySAAS' });
					// if ((key2 === 'vendorAgency') && value.masters[key2].access) reqJson.children.push({ path: '/masters/customeradmin', title: 'Master.SaasAgency', type: 'link', bookmark: true });
					if ((key2 === 'vendor') && value.masters[key2].access) reqJson.children.push({ path: '/masters/customer', title: 'Master.Vendor', type: 'link' });
					if ((key2 === 'deliveryStaff') && value.masters[key2].access) reqJson.children.push({ path: '/masters/deliverystaff', title: 'Master.Deliverystaff', type: 'link', bookmark: true });
					if ((key2 === 'customerMaster') && value.masters[key2].access) reqJson.children.push({ path: '/masters/customermaster', title: 'Master.CustomerMaster', type: 'link', bookmark: true, typeOf: 'CustomerMaster' });
					if ((key2 === 'customerGroup') && value.masters[key2].access) reqJson.children.push({ path: '/masters/customergroup', title: 'Master.CustomerGroup', type: 'link', bookmark: true, typeOf: 'CustomerGroup' });
					// if ((key2 === 'employee') && value.masters[key2].access) reqJson.children.push({ path: '/masters/employee', title: 'Master.Employee', type: 'link', bookmark: true });
				}
				// if (![constant.RoleId.superAdmin, constant.RoleId.admin].includes(this.localData.getItem(constant.localStorage.user_role_id))) {
				// 	reqJson.children.push({ path: '/masters/deliverypartner', title: 'Master.DeliveryPartner', type: 'link', bookmark: true });
				// }

				menuJson.push(reqJson)
			}
		}

		if (value.order && value.order.access) {
			if (value.order.access) {
				reqJson = {
					title: 'Orders.Text', icon: 'pocket', type: 'sub', badgeValue: '04', badgeType: 'success', active: true,
					children: []
				};

				for (let key2 in value.order) {
					if ((key2 === 'liveOrder') && value.order[key2].access) reqJson.children.push({ path: '/orders/list', title: 'Orders.BookingOrder', type: 'link', bookmark: true });
					if ((key2 === 'liveOrder') && value.order[key2].access) {
						// if (this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.vendor) {
						// 	reqJson.children.push({ icon: 'layers', path: '/orders/vendororder', title: 'Orders.addOrder', type: 'link', bookmark: true });
						// } else {
						// 	// reqJson.children.push({ icon: 'layers', path: '/orders/add', title: 'Orders.addOrder', type: 'link', bookmark: true });
						// }
					}
					// if ((key2 === 'scheduleOrder') && value.order[key2].access) {
					// 	if (this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.vendorAgency || this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.masterAgency || this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.agency) {
					// 		reqJson.children.push({ icon: 'layers', path: '/orders/cluborder', title: 'Orders.ClubOrder', type: 'link', bookmark: true });
					// 	}
					// }
					// if ((key2 === 'multipleOrder') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Orders.MultipleOrder', type: 'link' });
					if ((key2 === 'offlineOrder') && value.order[key2].access) reqJson.children.push({ path: '/orders/offorder', title: 'Orders.OfflineOrder', type: 'link', bookmark: true });
				}
				menuJson.push(reqJson)
			}
		}

		if (value.liveOrder && value.liveOrder.access) {
			if (value.liveOrder.access) {
				reqJson = { icon: 'shopping-bag', path: '/orders/list', title: 'Orders.BookingOrder', type: 'link', bookmark: true };
			}
			menuJson.push(reqJson)
		}
		if (value.scheduleOrder && value.scheduleOrder.access) {
			// if (this.localData.getItem(constant.localStorage.user_role_id) == constant.RoleId.vendor) {
			// 	reqJson = { icon: 'layers', path: '/orders/cluborder', title: 'Orders.ClubOrder', type: 'link', bookmark: true };
			// 	menuJson.push(reqJson)
			// }
		}

		// if (value.multipleOrder) {
		// 	reqJson = { icon: 'sunset', path: '/orders/employee1', title: 'Orders.MultipleOrder', type: 'link' };
		// 	menuJson.push(reqJson)
		// }
		if (value.offlineOrder) {
			reqJson = { icon: 'wifi-off', path: '/orders/offorder', title: 'Orders.OfflineOrder', type: 'link', bookmark: true };
			menuJson.push(reqJson)
		}



		// if (key1 === 'actionManagement') {

		// 	if (value[key1].access)
		// 		reqJson = {
		// 			title: 'ActionManage.Text', icon: 'database', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
		// 			children: []
		// 		};

		// 	for (let key2 in value[key1]) {
		// 		if ((key2 === 'billPayment') && value[key1][key2].access) reqJson.children.push({ path: '/actionmanage/actions', title: 'ActionManage.BillPayment', type: 'link' });
		// 		if ((key2 === 'paymentReport') && value[key1][key2].access) reqJson.children.push({ path: '/actionmanage/payment', title: 'ActionManage.PaymentReport', type: 'link' });
		// 	}
		// }

		if (value.receivables && value.receivables.access) {
			reqJson = {};
			if (value.receivables.access) {
				reqJson = {
					title: 'InvoiceManage.Text', icon: 'file-plus', type: 'sub', badgeValue: '03', badgeType: 'success', active: true,
					children: []
				};
				for (let key2 in value.receivables) {
					// if ((key2 === 'masterAgency') && value.receivables[key2].access) reqJson.children.push({ path: '/invoicemanage/masteragencyinvoice', title: 'InvoiceManage.MasterAgency', type: 'link', bookmark: true });
					if ((key2 === 'vendor') && value.receivables[key2].access) reqJson.children.push({ path: '/invoicemanage/customerinvoice', title: 'InvoiceManage.Vendor', type: 'link', bookmark: true });
					// if ((key2 === 'agency') && value.receivables[key2].access) reqJson.children.push({ path: '/invoicemanage/agencyinvoice', title: 'InvoiceManage.Agency', type: 'link', bookmark: true });
					// if ((key2 === 'vendorAgency') && value.receivables[key2].access) reqJson.children.push({ path: '/invoicemanage/customeragencyinvoice', title: 'InvoiceManage.SaasAgency', type: 'link', bookmark: true });
					if ((key2 === 'dsCodDailySettlement') && value.receivables[key2].access) reqJson.children.push({ path: '/invoicemanage/ridersettle', title: 'InvoiceManage.dsSettlement', type: 'link', bookmark: true });
					// if ((key2 === 'deliverChargeToAdloggs') && value.receivables[key2].access) reqJson.children.push({ path: '/invoicemanage/deliverychargead', title: 'InvoiceManage.DeliveryChargeToAd', type: 'link', bookmark: true });
					// if ((key2 === 'deliverChargeToMasterAgency') && value.receivables[key2].access) reqJson.children.push({ path: '/invoicemanage/deliverychargema', title: 'InvoiceManage.DeliveryChargeToMa', type: 'link', bookmark: true });
				}
				if (!_.isEmpty(reqJson)) menuJson.push(reqJson)
			}
		}
		if (value.payment && value.payment.access) {
			reqJson = {};
			if (value.payment.access)
				reqJson = {
					title: 'Payment.Text', icon: 'database', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
					children: []
				};

			for (let key2 in value.payment) {
				// if ((key2 === 'adloggsPayment') && value.payment[key2].access) reqJson.children.push({ path: '/payment/adpayment', title: 'Payment.AdloggsPayment', type: 'link', bookmark: true });
				// if ((key2 === 'masterAgencyPayment') && value.payment[key2].access) reqJson.children.push({ path: '/payment/masteragencypayment', title: 'Payment.MasterAgencyPayment', type: 'link' });
				if ((key2 === 'deliveryStaffPayment') && value.payment[key2].access) reqJson.children.push({ path: '/payment/deliverystaffpayment', title: 'Payment.DeliveryStaffPayment', type: 'link', bookmark: true });
				// if ((key2 === 'agencyPayment') && value.payment[key2].access) reqJson.children.push({ path: '/payment/agencypayment', title: 'Payment.AgencyPayment', type: 'link', bookmark: true });
				// if ((key2 === 'maDeliveryCharge') && value.payment[key2].access) reqJson.children.push({ path: '/payment/madeliverypayment', title: 'Payment.MasterAgencyDeliveryCharge', type: 'link', bookmark: true });
				// if ((key2 === 'aDeliveryCharge') && value.payment[key2].access) reqJson.children.push({ path: '/payment/adeliverypayment', title: 'Payment.AgencyDeliveryCharge', type: 'link', bookmark: true });
			}
			if (!_.isEmpty(reqJson)) menuJson.push(reqJson)
		}

		if (value.pricingAndTax && value.pricingAndTax.access) {
			reqJson = {};
			if (value.pricingAndTax.access)
				reqJson = {
					title: 'PricingAndTax.Text', icon: 'dollar-sign', type: 'sub', badgeValue: '04', badgeType: 'success', active: true,
					children: []
				};

			for (let key2 in value.pricingAndTax) {
				if ((key2 === 'deliveryStaff') && value.pricingAndTax[key2].access) reqJson.children.push({ path: '/priceandtax/deliveryStaffprice', title: 'PricingAndTax.DeliveryStaff', type: 'link', bookmark: true });
				// if ((key2 === 'masterAgency') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'PricingAndTax.MasterAgency', type: 'link' });
				if ((key2 === 'agency') && value.pricingAndTax[key2].access) reqJson.children.push({ path: '/priceandtax/agencypricing', title: 'PricingAndTax.Agency', type: 'link', bookmark: true });
				// if ((key2 === 'vendor') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'PricingAndTax.Vendor', type: 'link' });
			}
			if (!_.isEmpty(reqJson)) menuJson.push(reqJson)
		}

		if (value.settings && value.settings.access) {

			if (value.settings.access)
				reqJson = {
					title: 'Setting.Text', icon: 'settings', type: 'sub', badgeValue: '08', badgeType: 'success', active: true,
					children: []
				};

			for (let key2 in value.settings) {
				// if ((key2 === 'packages') && value.settings[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Setting.Packages', type: 'link' });
				if ((key2 === 'countries') && value.settings[key2].access) reqJson.children.push({ path: '/settings/countries', title: 'Setting.Countries', type: 'link', bookmark: true });
				if ((key2 === 'states') && value.settings[key2].access) reqJson.children.push({ path: '/settings/states', title: 'Setting.States', type: 'link', bookmark: true });
				if ((key2 === 'districts') && value.settings[key2].access) reqJson.children.push({ path: '/settings/district', title: 'Setting.District', type: 'link', bookmark: true });
				if ((key2 === 'cities') && value.settings[key2].access) reqJson.children.push({ path: '/settings/cities', title: 'Setting.Cities', type: 'link', bookmark: true });
				if ((key2 === 'vehicle') && value.settings[key2].access) reqJson.children.push({ path: '/settings/vehicle', title: 'Setting.Vehicle', type: 'link', bookmark: true });
				// if ((key2 === 'Announcement') && value.settings[key2].access) reqJson.children.push({ path: '/settings/announcement', title: 'Setting.Announcement', type: 'link', bookmark: true });
				// if ((key2 === 'offers') && value.settings[key2].access) reqJson.children.push({ path: '/settings/offers', title: 'Setting.Offers', type: 'link', bookmark: true });
				// if ((key2 === 'sms') && value.settings[key2].access) reqJson.children.push({ path: '/settings/sms', title: 'Setting.SmsSettings', type: 'link', bookmark: true });
			}
			menuJson.push(reqJson)
		}

		if (value.report && value.report.access) {
			if (value.report.access) {
				if (value.report.access) {
					reqJson = { icon: 'file-text', path: '/reports/ordersreport', title: 'Report.Text', type: 'link', bookmark: true };
					menuJson.push(reqJson)
				} else {
					reqJson = {
						title: 'Report.Text', icon: 'file-text', type: 'sub', badgeValue: '08', badgeType: 'success', active: true,
						children: []
					};
					if (value.report.order && value.report.order.access) {
						reqJson.children.push({ path: '/reports/ordersreport', title: 'Report.OrdersReport', type: 'link', bookmark: true });

						// for (let key2 in value.report.order) {

						// 	// if ((key2 === 'customer') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Report.Customers', type: 'link' });
						// 	// if ((key2 === 'masterAgency') && value.report[key2].access) reqJson.children.push({ path: '/reports/masteragency', title: 'Report.MasterAgency', type: 'link', bookmark: true });
						// 	// if ((key2 === 'agency') && value.report[key2].access) reqJson.children.push({ path: '/reports/agency', title: 'Report.Agency', type: 'link', bookmark: true });
						// 	// if ((key2 === 'vendor') && value.report[key2].access) reqJson.children.push({ path: '/reports/vendor', title: 'Report.Vendor', type: 'link', bookmark: true });
						// 	// if ((key2 === 'deliveryStaff') && value.report[key2].access) reqJson.children.push({ path: '/reports/deliverystaff', title: 'Report.Deliverystaff', type: 'link', bookmark: true });
						// 	if ((key2 === 'order') && value.report[key2].access) reqJson.children.push({ path: '/reports/ordersreport', title: 'Report.OrdersReport', type: 'link', bookmark: true });
						// 	if ((key2 === 'dsOrderNotification') && value.report[key2].access) reqJson.children.push({ path: '/reports/ordernotification', title: 'Report.Notification', type: 'link', bookmark: true });
						// 	// if ((key2 === 'growth') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Report.Growth', type: 'link' });
						// 	// if ((key2 === 'commission') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Report.Commission', type: 'link' });
						// }
					}
					if (value?.report?.dsOrderNotification && value?.report?.dsOrderNotification?.access) reqJson.children.push({ path: '/reports/ordernotification', title: 'Report.Notification', type: 'link', bookmark: true });
					if (value?.report?.transactionReport && value?.report?.transactionReport?.access) reqJson.children.push({ path: '/reports/transactionreport', title: 'Report.Transaction', type: 'link' });

					// if ([constant.RoleId.superAdmin].includes(this.localData.getItem(constant.localStorage.user_role_id))) {
					// 	reqJson.children.push({ path: '/reports/transactionreport', title: 'Report.Transaction', type: 'link' });
					// }
					menuJson.push(reqJson)
				}
			}
		}

		// if (value.wallet) {
		// 	if (value.wallet.access)
		// 		reqJson = { icon: 'credit-card', path: '/wallet', title: 'Wallet.Text', type: 'link', bookmark: true };
		// 	menuJson.push(reqJson)
		// }
		// if (value.employeeCrm) {

		// 	if (value.employeeCrm.access)
		// 		reqJson = {
		// 			title: 'EmployeeCRM.Text', icon: 'book-open', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
		// 			children: []
		// 		};

		// 	for (let key2 in value.employeeCrm) {
		// 		if ((key2 === 'payroll') && value.employeeCrm[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'EmployeeCRM.EmployeePayroll', type: 'link' });
		// 		if ((key2 === 'statistics') && value.employeeCrm[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'EmployeeCRM.EmployeeStatistics', type: 'link' });
		// 	}
		// 	menuJson.push(reqJson)
		// }
		// if (value.customerSupport) {

		// 	if (value.customerSupport.access)
		// 		reqJson = {
		// 			title: 'CustomerSupport.Text', icon: 'users', type: 'sub', badgeValue: '4', badgeType: 'success', active: true,
		// 			children: []
		// 		};

		// 	for (let key2 in value.customerSupport) {
		// 		if ((key2 === 'feedback') && value.customerSupport[key2].access) reqJson.children.push({ path: '/customersupport/feedback', title: 'CustomerSupport.Feedback', type: 'link', bookmark: true });
		// 		if ((key2 === 'masterAgencyQuerys') && value.customerSupport[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.MasterAgencyQueries', type: 'link', bookmark: true });
		// 		if ((key2 === 'agencyQuerys') && value.customerSupport[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.AgencyQueries', type: 'link', bookmark: true });
		// 		if ((key2 === 'vendorQuerys') && value.customerSupport[key2].access) reqJson.children.push({ path: '/customersupport/vendorquery', title: 'CustomerSupport.VendorQueries', type: 'link', bookmark: true });
		// 		if ((key2 === 'customerQuerys') && value.customerSupport[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.CustomerQueries', type: 'link', bookmark: true });
		// 		if ((key2 === 'deliveryStaffQuerys') && value.customerSupport[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.DeliveryStaffQueries', type: 'link', bookmark: true });
		// 	}
		// 	menuJson.push(reqJson)
		// }
		if (value?.riderMap?.access) {

			reqJson = { icon: 'map', path: '/map/deliverystaff', title: 'Maps.Text', type: 'link', bookmark: true };


			// if (value.map.access)
			// 	reqJson = {
			// 		title: 'Maps.Text', icon: 'map', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
			// 		children: []
			// 	};

			// for (let key2 in value.map) {
			// 	if ((key2 === 'countryHead') && value.map[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.CountryHead', type: 'link', bookmark: true });
			// 	if ((key2 === 'master') && value.map[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.Master', type: 'link', bookmark: true });
			// 	if ((key2 === 'agency') && value.map[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.Agency', type: 'link', bookmark: true });
			// 	if ((key2 === 'vendor') && value.map[key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.Vendor', type: 'link', bookmark: true });
			// 	if ((key2 === 'deliveryStaff') && value.map[key2].access) reqJson.children.push({ path: '/map/deliverystaff', title: 'Maps.DeliveryStaff', type: 'link', bookmark: true });
			// }
			menuJson.push(reqJson)
		}

		// if (value?.ondc?.access && [constant.RoleId.superAdmin, constant.RoleId.admin].includes(this.localData.getItem(constant.localStorage.user_role_id)) || this.localData.getItem(constant.localStorage.user_id) == constant.ondcUserId) {
		// 	reqJson = {
		// 		title: 'Ondc.Text', icon: 'globe', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
		// 		children: []
		// 	};

		// 	for (let key2 in value?.ondc) {
		// 		if ((key2 === 'orderList') && value?.ondc[key2].access) reqJson.children.push({ path: '/ondc/orderlist', title: 'Ondc.Order', type: 'link', bookmark: true });
		// 		if ((key2 === 'igm') && value?.ondc[key2].access) reqJson.children.push({ path: '/ondc/igm', title: 'Ondc.Igm', type: 'link', bookmark: true });
		// 		if ((key2 === 'rsp') && value?.ondc[key2].access) reqJson.children.push({ path: '/ondc/rsp', title: 'Ondc.Rsp', type: 'link', bookmark: true });
		// 	}


		// 	menuJson.push(reqJson)
		// }
		// if (constant.live) {
		// if ([constant.RoleId.masterAgency, constant.RoleId.agency, constant.RoleId.vendorAgency, constant.RoleId.vendor].includes(this.localData.getItem(constant.localStorage.user_role_id)) && (this.localData.getItem(constant.localStorage.developer_option) == true)) {
		// 	reqJson = {
		// 		title: 'Developer.Text', icon: 'globe', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
		// 		children: []
		// 	};
		// 	reqJson.children.push({ path: '/developer/webhook', title: 'Developer.Webhook', type: 'link', bookmark: true });
		// 	if (constant.live) {
		// 		reqJson.children.push({ path: '/developer/testwebhook', title: 'Developer.Testwebhook', type: 'link', bookmark: true });
		// 	}
		// 	menuJson.push(reqJson)
		// }
		// }

		// for (let key1 in value) {
		// 	var reqJson: any = {};
		// 	if (key1 === 'masters') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'Master.Text', icon: 'layout', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'admin') && value[key1][key2].access) reqJson.children.push({ path: '/masters/admin', title: 'Master.Admin', type: 'link' });
		// 			if ((key2 === 'masterAgency') && value[key1][key2].access) reqJson.children.push({ path: '/masters/masteragency', title: 'Master.MasterAgency', type: 'link' });
		// 			if ((key2 === 'vendorAgency') && value[key1][key2].access) reqJson.children.push({ path: '/masters/saasagency', title: 'Master.SaasAgency', type: 'link' });
		// 			if ((key2 === 'agency') && value[key1][key2].access) reqJson.children.push({ path: '/masters/agency', title: 'Master.Agency', type: 'link' });
		// 			if ((key2 === 'vendor') && value[key1][key2].access) reqJson.children.push({ path: '/masters/vendor', title: 'Master.Vendor', type: 'link' });
		// 			if ((key2 === 'deliveryStaff') && value[key1][key2].access) reqJson.children.push({ path: '/masters/deliverystaff', title: 'Master.Deliverystaff', type: 'link' });
		// 		}
		// 	}
		// 	if (key1 === 'order') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'Orders.Text', icon: 'pocket', type: 'sub', badgeValue: '04', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'booking') && value[key1][key2].access) reqJson.children.push({ path: '/orders/list', title: 'Orders.BookingOrder', type: 'link' });
		// 			// if ((key2 === 'multipleOrder') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Orders.MultipleOrder', type: 'link' });
		// 			// if ((key2 === 'offlineOrder') && value[key1][key2].access) reqJson.children.push({ path: '/orders/offorder', title: 'Orders.OfflineOrder', type: 'link' });
		// 		}
		// 	}
		// 	if (key1 === 'booking') {
		// 		reqJson = { icon: 'shopping-bag', path: '/orders/list', title: 'Orders.BookingOrder', type: 'link' };
		// 	}
		// 	if (key1 === 'multipleOrder') {
		// 		reqJson = { icon: 'sunset', path: '/orders/employee1', title: 'Orders.MultipleOrder', type: 'link' };
		// 	}
		// 	if (key1 === 'offlineOrder') {
		// 		reqJson = { icon: 'wifi-off', path: '/orders/offOrder', title: 'Orders.OfflineOrder', type: 'link' };
		// 	}
		// 	if (key1 === 'report') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'Report.Text', icon: 'file-text', type: 'sub', badgeValue: '08', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {

		// 			// if ((key2 === 'customer') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Report.Customers', type: 'link' });
		// 			if ((key2 === 'masterAgency') && value[key1][key2].access) reqJson.children.push({ path: '/reports/masteragency', title: 'Report.MasterAgency', type: 'link' });
		// 			if ((key2 === 'agency') && value[key1][key2].access) reqJson.children.push({ path: '/reports/agency', title: 'Report.Agency', type: 'link' });
		// 			if ((key2 === 'vendor') && value[key1][key2].access) reqJson.children.push({ path: '/reports/vendor', title: 'Report.Vendor', type: 'link' });
		// 			if ((key2 === 'deliveryStaff') && value[key1][key2].access) reqJson.children.push({ path: '/reports/deliverystaff', title: 'Report.Deliverystaff', type: 'link' });
		// 			if ((key2 === 'order') && value[key1][key2].access) reqJson.children.push({ path: '/reports/ordersreport', title: 'Report.OrdersReport', type: 'link' });
		// 			// if ((key2 === 'growth') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Report.Growth', type: 'link' });
		// 			// if ((key2 === 'commission') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Report.Commission', type: 'link' });
		// 		}
		// 	}

		// 	// if (key1 === 'actionManagement') {

		// 	// 	if (value[key1].access)
		// 	// 		reqJson = {
		// 	// 			title: 'ActionManage.Text', icon: 'database', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
		// 	// 			children: []
		// 	// 		};

		// 	// 	for (let key2 in value[key1]) {
		// 	// 		if ((key2 === 'billPayment') && value[key1][key2].access) reqJson.children.push({ path: '/actionmanage/actions', title: 'ActionManage.BillPayment', type: 'link' });
		// 	// 		if ((key2 === 'paymentReport') && value[key1][key2].access) reqJson.children.push({ path: '/actionmanage/payment', title: 'ActionManage.PaymentReport', type: 'link' });
		// 	// 	}
		// 	// }
		// 	if (key1 === 'invoiceManagement') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'InvoiceManage.Text', icon: 'file-plus', type: 'sub', badgeValue: '03', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'masterAgency') && value[key1][key2].access) reqJson.children.push({ path: '/invoicemanage/masteragencyinvoice', title: 'InvoiceManage.MasterAgency', type: 'link' });
		// 			if ((key2 === 'vendor') && value[key1][key2].access) reqJson.children.push({ path: '/invoicemanage/vendorinvoice', title: 'InvoiceManage.Vendor', type: 'link' });
		// 			if ((key2 === 'agency') && value[key1][key2].access) reqJson.children.push({ path: '/invoicemanage/agencyinvoice', title: 'InvoiceManage.Agency', type: 'link' });
		// 			// if ((key2 === 'vendorAgency') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'InvoiceManage.SaasAgency', type: 'link' });
		// 		}
		// 	}
		// 	if (key1 === 'payment') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'Payment.Text', icon: 'database', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'adloggsPayment') && value[key1][key2].access) reqJson.children.push({ path: '/payment/adpayment', title: 'Payment.AdloggsPayment', type: 'link' });
		// 			if ((key2 === 'masterAgencyPayment') && value[key1][key2].access) reqJson.children.push({ path: '/payment/masteragencypayment', title: 'Payment.MasterAgencyPayment', type: 'link' });
		// 			if ((key2 === 'deliveryStaffPayment') && value[key1][key2].access) reqJson.children.push({ path: '/payment/deliverystaffpayment', title: 'Payment.DeliveryStaffPayment', type: 'link' });
		// 		}
		// 	}
		// 	if (key1 === 'settings') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'Setting.Text', icon: 'settings', type: 'sub', badgeValue: '08', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'packages') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Setting.Packages', type: 'link' });
		// 			if ((key2 === 'countries') && value[key1][key2].access) reqJson.children.push({ path: '/settings/countries', title: 'Setting.Countries', type: 'link' });
		// 			if ((key2 === 'states') && value[key1][key2].access) reqJson.children.push({ path: '/settings/states', title: 'Setting.States', type: 'link' });
		// 			if ((key2 === 'district') && value[key1][key2].access) reqJson.children.push({ path: '/settings/district', title: 'Setting.District', type: 'link' });
		// 			if ((key2 === 'cities') && value[key1][key2].access) reqJson.children.push({ path: '/settings/cities', title: 'Setting.Cities', type: 'link' });
		// 			if ((key2 === 'vehicle') && value[key1][key2].access) reqJson.children.push({ path: '/settings/vehicle', title: 'Setting.Vehicle', type: 'link' });
		// 			if ((key2 === 'Announcement') && value[key1][key2].access) reqJson.children.push({ path: '/settings/announcement', title: 'Setting.Announcement', type: 'link' });
		// 			if ((key2 === 'offers') && value[key1][key2].access) reqJson.children.push({ path: '/settings/offers', title: 'Setting.Offers', type: 'link' });
		// 			if ((key2 === 'sms') && value[key1][key2].access) reqJson.children.push({ path: '/settings/sms', title: 'Setting.SmsSettings', type: 'link' });
		// 		}
		// 	}


		// 	if (key1 === 'pricingAndTax') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'PricingAndTax.Text', icon: 'dollar-sign', type: 'sub', badgeValue: '04', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'deliveryStaff') && value[key1][key2].access) reqJson.children.push({ path: '/priceandtax/deliveryStaffprice', title: 'PricingAndTax.DeliveryStaff', type: 'link' });
		// 			// if ((key2 === 'masterAgency') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'PricingAndTax.MasterAgency', type: 'link' });
		// 			if ((key2 === 'agency') && value[key1][key2].access) reqJson.children.push({ path: '/priceandtax/agencypricing', title: 'PricingAndTax.Agency', type: 'link' });
		// 			// if ((key2 === 'vendor') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'PricingAndTax.Vendor', type: 'link' });

		// 		}
		// 	}

		// 	if (key1 === 'employeeCrm') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'EmployeeCRM.Text', icon: 'book-open', type: 'sub', badgeValue: '02', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'payroll') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'EmployeeCRM.EmployeePayroll', type: 'link' });
		// 			if ((key2 === 'statistics') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'EmployeeCRM.EmployeeStatistics', type: 'link' });
		// 		}
		// 	}
		// 	if (key1 === 'customerSupport') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'CustomerSupport.Text', icon: 'users', type: 'sub', badgeValue: '4', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'feedback') && value[key1][key2].access) reqJson.children.push({ path: '/customersupport/feedback', title: 'CustomerSupport.Feedback', type: 'link' });
		// 			if ((key2 === 'masterAgencyQuerys') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.MasterAgencyQueries', type: 'link' });
		// 			if ((key2 === 'agencyQuerys') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.AgencyQueries', type: 'link' });
		// 			if ((key2 === 'vendorQuerys') && value[key1][key2].access) reqJson.children.push({ path: '/customersupport/vendorquery', title: 'CustomerSupport.VendorQueries', type: 'link' });
		// 			if ((key2 === 'customerQuerys') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.CustomerQueries', type: 'link' });
		// 			if ((key2 === 'deliveryStaffQuerys') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'CustomerSupport.DeliveryStaffQueries', type: 'link' });
		// 		}
		// 	}
		// 	if (key1 === 'map') {

		// 		if (value[key1].access)
		// 			reqJson = {
		// 				title: 'Maps.Text', icon: 'map', type: 'sub', badgeValue: '05', badgeType: 'success', active: true,
		// 				children: []
		// 			};

		// 		for (let key2 in value[key1]) {
		// 			if ((key2 === 'countryHead') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.CountryHead', type: 'link' });
		// 			if ((key2 === 'master') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.Master', type: 'link' });
		// 			if ((key2 === 'agency') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.Agency', type: 'link' });
		// 			if ((key2 === 'vendor') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.Vendor', type: 'link' });
		// 			if ((key2 === 'deliveryStaff') && value[key1][key2].access) reqJson.children.push({ path: '/masters/employee1', title: 'Maps.DeliveryStaff', type: 'link' });
		// 		}
		// 	}

		// 	menuJson.push(reqJson)
		// }
		this.items.next(menuJson);
		this.headerItems.next(headerMenuArray);

		//Permission
		if (value.masters) {
			for (let key in value.masters) {
				if ((key === 'admin') && value.masters[key].access) {
					constant.Permission.masters.admin.add = value.masters.admin?.add;
					constant.Permission.masters.admin.edit = value.masters.admin?.add;
					constant.Permission.masters.admin.delete = value.masters.admin?.add;
					// constant.Permission.masters.admin.view = value.masters.admin?.add;
				};
				if ((key === 'vendor') && value.masters[key].access) {
					constant.Permission.masters.vendor.add = value.masters.vendor?.add;
					constant.Permission.masters.vendor.edit = value.masters.vendor?.edit;
					constant.Permission.masters.vendor.delete = value.masters.vendor?.delete;
					// constant.Permission.masters.vendor.view = value.masters.vendor?.view;
				};
				if ((key === 'masterAgency') && value.masters[key].access) {
					constant.Permission.masters.masterAgency.add = value.masters.masterAgency?.add;
					constant.Permission.masters.masterAgency.edit = value.masters.masterAgency?.edit;
					constant.Permission.masters.masterAgency.delete = value.masters.masterAgency?.delete;
					// constant.Permission.masters.masterAgency.view = value.masters.masterAgency?.view;
				};
				if ((key === 'vendorAgency') && value.masters[key].access) {
					constant.Permission.masters.vendorAgency.add = value.masters.vendorAgency?.add;
					constant.Permission.masters.vendorAgency.edit = value.masters.vendorAgency?.edit;
					constant.Permission.masters.vendorAgency.delete = value.masters.vendorAgency?.delete;
					// constant.Permission.masters.vendorAgency.view = value.masters.vendorAgency?.view;
				};
				if ((key === 'agency') && value.masters[key].access) {
					constant.Permission.masters.agency.add = value.masters.agency?.add;
					constant.Permission.masters.agency.edit = value.masters.agency?.edit;
					constant.Permission.masters.agency.delete = value.masters.agency?.delete;
					// constant.Permission.masters.agency.view = value.masters.agency?.view;
				};
			}
		}
		if (value.order) {
			for (let key in value.order) {
				if ((key === 'liveOrder') && value.order[key].access) {
					constant.Permission.order.liveOrder.access = value.order.liveOrder?.access;
					constant.Permission.order.liveOrder.add = value.order.liveOrder?.add;
					constant.Permission.order.liveOrder.edit = value.order.liveOrder?.edit;
					constant.Permission.order.liveOrder.delete = value.order.liveOrder?.delete;
					// constant.Permission.order.liveOrder.view = value.order.booking?.view;
				}
				if ((key === 'multipleOrder') && value.order[key].access) {
					constant.Permission.order.multipleOrder.add = value.order.multipleOrder?.add;
					constant.Permission.order.multipleOrder.edit = value.order.multipleOrder?.edit;
					constant.Permission.order.multipleOrder.delete = value.order.multipleOrder?.delete;
					// constant.Permission.order.multipleOrder.view = value.order.multipleOrder?.view;
				}
				if ((key === 'scheduleOrder') && value.order[key].access) {
					constant.Permission.order.scheduleOrder.add = value.order.scheduleOrder?.add;
					constant.Permission.order.scheduleOrder.edit = value.order.scheduleOrder?.edit;
					constant.Permission.order.scheduleOrder.delete = value.order.scheduleOrder?.delete;
					// constant.Permission.order.scheduleOrder.view = value.order.scheduleOrder?.view;
				}
				if ((key === 'offlineOrder') && value.order[key].access) {
					constant.Permission.order.offlineOrder.add = value.order.offlineOrder?.add;
					constant.Permission.order.offlineOrder.edit = value.order.offlineOrder?.edit;
					constant.Permission.order.offlineOrder.delete = value.order.offlineOrder?.delete;
					// constant.Permission.order.offlineOrder.view = value.order.offlineOrder?.view;
				}
			}
		}
		if (value.liveOrder) {
			constant.Permission.order.liveOrder.access = value.liveOrder?.access;
			constant.Permission.order.liveOrder.add = value.liveOrder?.add;
			constant.Permission.order.liveOrder.edit = value.liveOrder?.edit;
			constant.Permission.order.liveOrder.delete = value.liveOrder?.delete;
			// constant.Permission.order.liveOrder.view = value.liveOrder?.view;
		}
		if (value.report) {
			if (value?.report?.order && value?.report?.order?.access) {
				constant.Permission.report.order.access = value?.report?.order?.access;
			}
			if (value?.report?.order?.basicOrder && value?.report?.order?.basicOrder.access) {
				constant.Permission.report.order.basicOrder.access = value?.report?.order?.basicOrder?.access;
			}
			if (value?.report?.order?.issueOrder && value?.report?.order?.issueOrder.access) {
				constant.Permission.report.order.issueOrder.access = value?.report?.order?.issueOrder?.access;
			}
			if (value?.report?.order?.customerWiseOrder && value?.report?.order?.customerWiseOrder?.access) {
				constant.Permission.report.order.customerWiseOrder.access = value?.report?.order?.customerWiseOrder?.access;
			}
			if (value?.report?.order?.orderAnalytics && value?.report?.order?.orderAnalytics?.access) {
				constant.Permission.report.order.orderAnalytics.access = value?.report?.order?.orderAnalytics?.access;
			}
			if (value?.report?.order?.codOrder && value?.report?.order?.codOrder?.access) {
				constant.Permission.report.order.codOrder.access = value?.report?.order?.codOrder?.access;
			}
			if (value?.report?.order?.['3plCodOrder'] && value?.report?.order?.['3plCodOrder']?.access) {
				constant.Permission.report.order['3plCodOrder'].access = value?.report?.order?.['3plCodOrder']?.access;
			}
			if (value?.report?.order?.riderMg && value?.report?.order?.riderMg?.access) {
				constant.Permission.report.order.riderMg.access = value?.report?.order?.riderMg?.access;
			}
			if (value?.report?.order?.deliveryStaffOrder && value?.report?.order?.deliveryStaffOrder?.access) {
				constant.Permission.report.order.deliveryStaff.access = value?.report?.order?.deliveryStaffOrder?.access;
			}

			// for (let key in value.report) {
			// if ((key === 'customer') && value.report[key].access) {
			// 	constant.Permission.report.customer.access = value.report.customer?.access;
			// 	constant.Permission.report.customer.view = value.report.customer?.view;
			// }
			// if ((key === 'masterAgency') && value.report[key].access) {
			// 	constant.Permission.report.masterAgency.access = value.report.masterAgency?.access;
			// 	constant.Permission.report.masterAgency.view = value.report.masterAgency?.view;
			// }
			// if ((key === 'agency') && value.report[key].access) {
			// 	constant.Permission.report.agency.access = value.report.agency?.access;
			// 	constant.Permission.report.agency.view = value.report.agency?.view;
			// }
			// if ((key === 'vendor') && value.report[key].access) {
			// 	constant.Permission.report.vendor.access = value.report.vendor?.access;
			// 	constant.Permission.report.vendor.view = value.report.vendor?.view;
			// }
			// if ((key === 'vendorWise') && value.report[key].access) {
			// 	constant.Permission.report.vendorWise.access = value.report.vendorWise?.access;
			// 	constant.Permission.report.vendorWise.view = value.report.vendorWise?.view;
			// }
			// if ((key === 'deliveryStaff') && value.report[key].access) {
			// 	constant.Permission.report.deliveryStaff.access = value.report.deliveryStaff?.access;
			// 	constant.Permission.report.deliveryStaff.view = value.report.deliveryStaff?.view;
			// }
			// if ((key === 'order') && value.report[key].access) {
			// 	constant.Permission.report.order.access = value.report.order?.access;
			// 	constant.Permission.report.order.view = value.report.order?.view;
			// }
			// if ((key === 'growth') && value.report[key].access) {
			// 	constant.Permission.report.growth.access = value.report.growth?.access;
			// 	constant.Permission.report.growth.view = value.report.growth?.view;
			// }
			// if ((key === 'commission') && value.report[key].access) {
			// 	constant.Permission.report.commission.access = value.report.commission?.access;
			// 	constant.Permission.report.commission.view = value.report.commission?.view;
			// }
			// }
		}
		if (value.receivables) {
			for (let key in value.receivables) {
				if ((key === 'masterAgency') && value.receivables[key].access) {
					constant.Permission.receivables.masterAgency.access = value.receivables.masterAgency?.access;
				}
				if ((key === 'agency') && value.receivables[key].access) {
					constant.Permission.receivables.agency.access = value.receivables.agency?.access;
				}
				if ((key === 'vendor') && value.receivables[key].access) {
					constant.Permission.receivables.vendor.access = value.receivables.vendor?.access;
				}
			}
		}
		if (value.payment) {
			for (let key in value.payment) {
				if ((key === 'maDeliveryCharge') && value.payment[key].access) {
					constant.Permission.payment.maDeliveryCharge.access = value.payment.maDeliveryCharge?.access;
				}
				if ((key === 'aDeliveryCharge') && value.payment[key].access) {
					constant.Permission.payment.aDeliveryCharge.access = value.payment.aDeliveryCharge?.access;
				}
			}
		}
		if (value.pricingAndTax) {
			for (let key in value.pricingAndTax) {
				if ((key === 'agency') && value.pricingAndTax[key].access) {
					constant.Permission.pricingAndTax.agency.access = value.pricingAndTax.agency?.access;
					constant.Permission.pricingAndTax.agency.add = value.pricingAndTax.agency?.add;
					constant.Permission.pricingAndTax.agency.edit = value.pricingAndTax.agency?.edit;
					constant.Permission.pricingAndTax.agency.delete = value.pricingAndTax.agency?.delete;
				}
				if ((key === 'deliveryStaff') && value.pricingAndTax[key].access) {
					constant.Permission.pricingAndTax.deliveryStaff.access = value.pricingAndTax.deliveryStaff?.access;
					constant.Permission.pricingAndTax.deliveryStaff.add = value.pricingAndTax.deliveryStaff?.add;
					constant.Permission.pricingAndTax.deliveryStaff.edit = value.pricingAndTax.deliveryStaff?.edit;
					constant.Permission.pricingAndTax.deliveryStaff.delete = value.pricingAndTax.deliveryStaff?.delete;
				}
			}
		}
		if (value.settings) {
			for (let key in value.settings) {
				if ((key === 'packages') && value.settings[key].access) {
					constant.Permission.settings.packages.access = value.settings.packages?.access;
					constant.Permission.settings.packages.add = value.settings.packages?.add;
					constant.Permission.settings.packages.edit = value.settings.packages?.edit;
					constant.Permission.settings.packages.delete = value.settings.packages?.delete;
					constant.Permission.settings.packages.view = value.settings.packages?.view;

				}
				if ((key === 'countries') && value.settings[key].access) {
					constant.Permission.settings.countries.access = value.settings.countries?.access;
					constant.Permission.settings.countries.add = value.settings.countries?.add;
					constant.Permission.settings.countries.edit = value.settings.countries?.edit;
					constant.Permission.settings.countries.delete = value.settings.countries?.delete;
					constant.Permission.settings.countries.view = value.settings.countries?.view;
				}
				if ((key === 'states') && value.settings[key].access) {
					constant.Permission.settings.states.access = value.settings.states?.access;
					constant.Permission.settings.states.add = value.settings.states?.add;
					constant.Permission.settings.states.edit = value.settings.states?.edit;
					constant.Permission.settings.states.delete = value.settings.states?.delete;
					// constant.Permission.settings.states.view = value.settings.states?.view;
				}
				if ((key === 'districts') && value.settings[key].access) {
					constant.Permission.settings.districts.access = value.settings.districts?.access;
					constant.Permission.settings.districts.add = value.settings.districts?.add;
					constant.Permission.settings.districts.edit = value.settings.districts?.edit;
					constant.Permission.settings.districts.delete = value.settings.districts?.delete;
					constant.Permission.settings.districts.view = value.settings.districts?.view;
				}
				if ((key === 'cities') && value.settings[key].access) {
					constant.Permission.settings.cities.access = value.settings.cities?.access;
					constant.Permission.settings.cities.add = value.settings.cities?.add;
					constant.Permission.settings.cities.edit = value.settings.cities?.edit;
					constant.Permission.settings.cities.delete = value.settings.cities?.delete;
					constant.Permission.settings.cities.view = value.settings.cities?.view;
				}
				if ((key === 'vehicle') && value.settings[key].access) {
					constant.Permission.settings.vehicle.access = value.settings.vehicle?.access;
					constant.Permission.settings.vehicle.add = value.settings.vehicle?.add;
					constant.Permission.settings.vehicle.edit = value.settings.vehicle?.edit;
					constant.Permission.settings.vehicle.delete = value.settings.vehicle?.delete;
					constant.Permission.settings.vehicle.view = value.settings.vehicle?.view;
				}
				if ((key === 'Announcement') && value.settings[key].access) {
					constant.Permission.settings.Announcement.access = value.settings.Announcement?.access;
					constant.Permission.settings.Announcement.add = value.settings.Announcement?.add;
					constant.Permission.settings.Announcement.edit = value.settings.Announcement?.edit;
					constant.Permission.settings.Announcement.delete = value.settings.Announcement?.delete;
					// constant.Permission.settings.Announcement.view = value.settings.Announcement?.view;
				}
				if ((key === 'offers') && value.settings[key].access) {
					constant.Permission.settings.offers.access = value.settings.offers?.access;
					constant.Permission.settings.offers.add = value.settings.offers?.add;
					constant.Permission.settings.offers.edit = value.settings.offers?.edit;
					constant.Permission.settings.offers.delete = value.settings.offers?.delete;
					constant.Permission.settings.offers.view = value.settings.offers?.view;
				}
				if ((key === 'sms') && value.settings[key].access) {
					constant.Permission.settings.sms.access = value.settings.sms?.access;
					constant.Permission.settings.sms.add = value.settings.sms?.add;
					constant.Permission.settings.sms.edit = value.settings.sms?.edit;
					constant.Permission.settings.sms.delete = value.settings.sms?.delete;
					constant.Permission.settings.sms.view = value.settings.sms?.view;
				}
			}
		}

	}

}
